'use client';
import { useEffect } from 'react';

export const useReveal = (selectors: string[] = ['.feature-card', '.step-card']) => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => e.isIntersecting && e.target.classList.add('reveal')),
      { threshold: 0.15 }
    );
    const nodes = selectors.flatMap(sel => Array.from(document.querySelectorAll(sel)));
    nodes.forEach(n => observer.observe(n));
    return () => observer.disconnect();
  }, [selectors]);
};
